var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoVacation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.97,
    y: 17.47,
    width: 16.71,
    height: 22.79,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.89,13.61h.07v-.08l-.07-5.27h-9.13l-.07,5.26v.09h9.2Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46,17.47h-2.01v22.79h2.01c1.04,0,1.88-.84,1.88-1.88V19.36c0-1.04-.85-1.88-1.88-1.88Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2,17.47h-2.01c-1.04,0-1.88,.84-1.88,1.88v19.02c0,1.04,.85,1.88,1.88,1.88h2.01V17.47Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.46,13.7h-5.73c0-.06,0-.12,0-.18v-5.17c0-2.13-1.72-3.86-3.84-3.86h-9.13c-2.12,0-3.84,1.73-3.84,3.86v5.17c0,.07,0,.12,0,.18h-5.73c-3.12,0-5.65,2.54-5.65,5.65v19.02c0,3.12,2.54,5.65,5.65,5.65h28.27c3.12,0,5.65-2.54,5.65-5.65V19.36c0-3.12-2.54-5.65-5.65-5.65Zm-18.77-.18l.07-5.26h9.13l.07,5.27v.08h-9.27v-.09Zm12.99,3.95v22.79H14.97V17.47H31.68ZM7.31,38.38V19.36c0-1.04,.85-1.88,1.88-1.88h2.01v22.79h-2.01c-1.04,0-1.88-.84-1.88-1.88Zm32.03,0c0,1.04-.85,1.88-1.88,1.88h-2.01V17.47h2.01c1.04,0,1.88,.84,1.88,1.88v19.02Z",
    fill: outlineColor
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.68,
    y: 0.26,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVacation);
export default __webpack_public_path__ + "static/media/ico-vacation.1c46a69f6a47b293c53e2e2e71a479b2.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;